import { DocumentOwner } from 'modules/Documents/models/document';
import { VerifactuFrozenOwner } from 'modules/Documents/models/verifactuInvoice';

export const normalizeVerifactuOwnerToBusiness = (
  verifactuOwner: VerifactuFrozenOwner
): DocumentOwner | undefined => {
  if (!verifactuOwner) {
    return undefined;
  }

  return {
    fiscalName: verifactuOwner?.fiscalName,
    vatNumber: verifactuOwner?.vatNumber,
    address: {
      postalAddress: verifactuOwner?.address.postalAddress,
      postalCode: verifactuOwner?.address.postalCode,
      city: verifactuOwner?.address.city,
      province: verifactuOwner?.address.province,
      country: verifactuOwner?.address.country,
    },
  };
};
